import { ACTIONS } from '../Constants';

const getInitialState = () => ({
    byEmail: {}
});

export default (state = getInitialState(), action) => {
    let newByEmail;
    switch (action.type) {
        case ACTIONS.PUT_SUPPRESSION_DATA:
        case ACTIONS.GET_SUPPRESSION_DATA: {
            const { suppressionData } = action.payload;
            newByEmail = {
                ...state.byEmail,
                [suppressionData.email]: suppressionData
            };
            return {
                ...state,
                byEmail: newByEmail
            };
        }
        default:
            return state;
    }
};
